export const createWidgetModuleExportName = "createWidgetModule";
